import request from '@/utils/request'

export default {
  getIssuers(name) {
    const params = { name }
    return request.get('/sm-svc/getIssuers', { params })
  },

  createIssuer(issuerInfo) {
    return request.post('/sm-svc/createIssuer', issuerInfo)
  },
  updateIssuer(issuerInfo) {
    return request.post('/sm-svc/updateIssuer', issuerInfo)
  },
}
